import { readable } from 'svelte/store';
import { drawer } from './drawer';

export const aboveLg = readable(
  typeof window !== 'undefined' ? window.matchMedia(`(min-width: 1024px)`).matches : false,
  (set) => {
    if (typeof window === 'undefined') return;

    const update = (event: MediaQueryListEvent) => {
      set(event.matches);
      drawer.close();
    };

    const mediaQueryList = window.matchMedia(`(min-width: 1024px)`);
    mediaQueryList.addEventListener('change', update);

    return () => mediaQueryList.removeEventListener('change', update);
  }
);
